import { ReactNode } from 'react'

import { useSelection } from './use-selection'
import SelectionDataContext from './selection-state-context'

/**
 * Состояние в контексте для хранения выделенных строк таблицы
 */

type Props = {
  children: ReactNode
}

export const SelectionStateProvider = ({ children }: Props) => {
  const value = useSelection()

  return (
    <SelectionDataContext.Provider value={value}>
      {children}
    </SelectionDataContext.Provider>
  )
}
